<!--
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
-->
<template>
  <div class="unknown-block">
    <i class="ri-error-warning-line unknown-block-icon"></i>
    <p>{{ $t("dashboard.unknownBlockType", { type: type }) }}</p>
  </div>
</template>

<script>
export default {
  name: "UnknownBlockType",
  props: {
    type: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.unknown-block {
  text-align: center;
  color: var(--p-text-muted-color);
  padding: 1rem;
}

.unknown-block-icon {
  font-size: 2.25rem;
  margin-bottom: 0.5rem;
}
</style>
